import React from 'react';
import { FormControl, FormLabel, Input, Tooltip } from '@chakra-ui/react';

export const ProfileField = ({
	state,
	setter,
	name,
	en,
	ru,
	placeholder,
	type = 'text',
	isDisabled = false,
	...props
}) => {
	const onChange = e => setter({ ...state, [e.target.name]: e.target.value });

	const tooltip = { label: ru, placement: 'top-start' };
	const input = {
		onChange,
		name,
		placeholder,
		value: state[name],
		type,
		isDisabled,
	};

	return (
		<FormControl {...props}>
			<Tooltip {...tooltip}>
				<FormLabel>{en}</FormLabel>
			</Tooltip>
			<Input {...input} />
		</FormControl>
	);
};
